import { API_BASE_URL } from '../config/apiBase';

export type NoticeCategory = '버그수정' | '업데이트' | '점검안내';

export interface PublicNoticeSummary {
  id: number;
  title: string;
  category: NoticeCategory;
  created_at: string | null;
  updated_at: string | null;
}

export interface PublicNoticeDetail extends PublicNoticeSummary {
  content: string;
}

async function handleJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.json().catch(() => null);
    throw new Error(typeof body?.detail === 'string' ? body.detail : '요청에 실패했습니다.');
  }
  return res.json() as Promise<T>;
}

export async function fetchLatestNotice(): Promise<PublicNoticeSummary | null> {
  const res = await fetch(`${API_BASE_URL}/api/notice/latest`);
  const data = await handleJson<{ item: PublicNoticeSummary | null }>(res);
  return data.item;
}

export async function fetchPublicNotices(): Promise<PublicNoticeSummary[]> {
  const res = await fetch(`${API_BASE_URL}/api/notice`);
  const data = await handleJson<{ items: PublicNoticeSummary[] }>(res);
  return data.items || [];
}

export async function fetchPublicNotice(id: number): Promise<PublicNoticeDetail> {
  const res = await fetch(`${API_BASE_URL}/api/notice/${id}`);
  return handleJson<PublicNoticeDetail>(res);
}
